import React from 'react';
import { Card, CardContent, CardActions } from '@material-ui/core';

const SarasCard = (props) => {
const { children, actions, containerClass, actionClass, actionsVisible = false } = props;

const cardClass = containerClass || 'uiCard';
const gridClass = 'uiCardGrid';
const bodyClass = 'uiCardBody';
const actionsSlotClass = actionClass || 'uiCardActions';
const shouldRenderActions = actionsVisible || !!actions;

return (
<Card className={cardClass}>
  <div className={gridClass}>
    <CardContent className={bodyClass}>
      {children}
    </CardContent>
    {shouldRenderActions && (
      <CardActions className={actionsSlotClass}>
        {actions}
      </CardActions>
    )}
  </div>
</Card>
);
}

export default SarasCard;
